import { render, staticRenderFns } from "./InvoicesFBMTableMobile.vue?vue&type=template&id=205e7824&scoped=true"
import script from "./InvoicesFBMTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesFBMTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesFBMTableMobile.vue?vue&type=style&index=0&id=205e7824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e7824",
  null
  
)

export default component.exports